import '.a{display:flex;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.j{gap:16px;}.ssr-plugin'
import '.f{width:100%;}.ssr-plugin'
import { FC } from 'react'
import { Layout } from './Layout'
import { Navigation } from '../components/Navigation'
import { Canva } from '../components/Canva'
import { Text } from '../components/Text'
import { useTheme } from '../providers/useTheme'
import { useAppCtx } from '../providers/useAppCtx'
import { styled } from 'inlines'
import { useContentQuery } from '../hooks/useContentQuery'
import { Html } from '../components/Html'
import {
  replaceMustachesInString,
  useMustacheIndex,
} from '../hooks/useTranslations'

export type ContentProps = {
  'aria-label'?: {
    nav: string
    footer: string
  }
}

export const Content: FC<ContentProps> = ({
  'aria-label': ariaLabelProp = {
    nav: 'Main navigation',
    footer: 'Footer navigation',
  },
}) => {
  const { languages, votesCount } = useAppCtx()
  const { data: sequence = {} } = useContentQuery('sequence')
  const mustacheIndex = useMustacheIndex()
  const { colors } = useTheme()
  const isVoting = sequence?.sequenceType === 'voting'

  return (
    <Layout
      style={{
        padding: '32px 24px 96px',
        gap: 32,
      }}
    >
      <Layout.Navbar>
        <Navigation
          as="nav"
          aria-label={ariaLabelProp.nav}
          isCartVisible={isVoting}
          isExpandable
          cartItems={votesCount}
          languages={languages}
        />
      </Layout.Navbar>

      {sequence?.media && (
        <Layout.Top
          style={{
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
            flex: 1,
            maxWidth: 480,
            maxHeight: 296,
          }}
        >
          <Canva
            src={sequence?.media?.src}
            size={{
              width: 180,
              height: 180,
            }}
          />
        </Layout.Top>
      )}

      <Layout.Middle>
        <div className="a i d c j f"
        >
          {sequence?.prompt && (
            <Text
              color={'gradient'}
              variant="title"
              isMultiline
              style={{ textAlign: 'center' }}
            >
              {replaceMustachesInString(sequence?.prompt, mustacheIndex)}
            </Text>
          )}

          {sequence?.details && (
            <Html color={colors.textSecondary}>
              {replaceMustachesInString(sequence?.details, mustacheIndex)}
            </Html>
          )}
        </div>
      </Layout.Middle>

      <Layout.Footer>
        <Navigation
          as="footer"
          aria-label={ariaLabelProp.footer}
          languages={languages}
        />
      </Layout.Footer>
    </Layout>
  )
}
